import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-ne-kadar-sure-gider/page.tsx");
